(() => {
  const roots = document.querySelectorAll('[data-gs-quiz]');
  if (!roots.length) return;

  const questions = [
    {
      id: 'q1',
      type: 'multi',
      max: 3,
      text: 'Wie fühlst du dich in den letzten 2–4 Wochen am häufigsten?',
      hint: 'Mehrere Antworten möglich (max. 3)',
      options: [
        ['exhausted', 'Emotional erschöpft, auch wenn ich genug schlafe'],
        ['irritated', 'Gereizt oder überfordert ohne klaren Grund'],
        ['unmotivated', 'Antriebslos, obwohl ich eigentlich funktionieren will'],
        ['moodswings', 'Stimmungsschwankungen, die ich selbst nicht erklären kann'],
        ['restless', 'Eigentlich okay, aber innerlich unruhig und angespannt']
      ]
    },
    {
      id: 'q2',
      type: 'single',
      auto: true,
      text: 'Was belastet dich aktuell am meisten?',
      hint: 'Wähle die Antwort, die am ehesten zutrifft.',
      options: [
        ['mental', 'Mentale Überlastung – zu viele Aufgaben gleichzeitig'],
        ['hormonal', 'Hormonelle Schwankungen (Zyklus, Wechseljahre, nach Schwangerschaft)'],
        ['sleep', 'Schlechter Schlaf oder Einschlafprobleme'],
        ['emotional-drain', 'Emotional für andere da sein müssen, aber selbst leer sein'],
        ['unknown', 'Ich weiß es nicht genau – es stimmt einfach gerade nichts']
      ]
    },
    {
      id: 'q3',
      type: 'multi',
      max: 5,
      text: 'Hast du in letzter Zeit eines dieser körperlichen Signale bemerkt?',
      hint: 'Mehrere Antworten möglich',
      options: [
        ['cravings', 'Heißhunger auf Süßes, besonders abends'],
        ['tension', 'Verspannungen im Nacken- und Schulterbereich'],
        ['headache', 'Kopfschmerzen ohne offensichtlichen Grund'],
        ['digestion', 'Verdauungsprobleme oder Magendrücken bei Stress'],
        ['none', 'Keines davon']
      ]
    },
    {
      id: 'q4',
      type: 'single',
      auto: true,
      text: 'Wie gehst du typischerweise mit schlechten Tagen um?',
      hint: 'Sei ehrlich – es gibt keine falsche Antwort.',
      options: [
        ['emotional-eating', 'Ich esse mehr als ich sollte – besonders Süßes oder Herzhaftes'],
        ['withdraw', 'Ich ziehe mich zurück und brauche viel Ruhe'],
        ['push-through', 'Ich funktioniere weiter, merke aber, dass ich kürzer angebunden bin'],
        ['breathe', 'Ich versuche es wegzuatmen, aber es hält nicht lange an'],
        ['cope-well', 'Ich komme eigentlich gut damit klar']
      ]
    },
    {
      id: 'q5',
      type: 'multi',
      max: 6,
      text: 'Was hast du bisher versucht, um dich besser zu fühlen?',
      hint: 'Alles, was zutrifft',
      options: [
        ['sleep-more', 'Mehr schlafen / früher ins Bett'],
        ['sport', 'Sport oder regelmäßige Bewegung'],
        ['meditation', 'Meditation oder Atemübungen'],
        ['diet', 'Ernährungsumstellungen'],
        ['supplements', 'Supplements oder Vitamine (andere)'],
        ['nothing', 'Ich habe noch nichts Gezieltes versucht']
      ]
    },
    {
      id: 'q6',
      type: 'single',
      auto: true,
      text: 'Seit wann bemerkst du diese Veränderungen in deiner Stimmung oder Energie?',
      hint: 'Ungefähre Angabe reicht vollkommen aus.',
      options: [
        ['recent', 'Weniger als 4 Wochen – das ist neu'],
        ['months', '1–3 Monate'],
        ['long', 'Mehr als 3 Monate'],
        ['always', 'Schon sehr lange – ich dachte, das ist einfach wie ich bin']
      ]
    },
    {
      id: 'q7',
      type: 'single',
      auto: true,
      text: 'Wie alt bist du?',
      hint: 'Das hilft, dein Profil noch genauer zuzuordnen.',
      options: [
        ['under30', 'Unter 30'],
        ['30-39', '30–39'],
        ['40-49', '40–49'],
        ['50plus', '50 oder älter']
      ]
    },
    {
      id: 'q8',
      type: 'single',
      text: 'Was würde sich für dich am meisten verändern, wenn du dein Gleichgewicht zurückgewinnst?',
      hint: 'Diese Antwort ist dein persönlicher Leitsatz – nimm dir einen Moment.',
      options: [
        ['morning-joy', 'Ich würde morgens aufwachen und mich auf den Tag freuen'],
        ['no-outbursts', 'Ich würde nicht mehr so schnell ausrasten oder weinen'],
        ['no-cravings', 'Ich würde endlich meinen Heißhunger unter Kontrolle haben'],
        ['clarity', 'Ich würde im Alltag präsenter, klarer und fokussierter sein'],
        ['myself', 'Ich würde mich wieder mehr wie ich selbst fühlen']
      ]
    }
  ];

  const profiles = {
    cortisol: {
      name: 'Die Cortisol-Getriebene',
      tag: 'Du trägst zu viel auf einmal – dein Nervensystem hat das schon lange bemerkt.',
      sub: 'Für deinen Typ empfehlen wir gezielte Unterstützung des Nervensystems über mindestens 8 Wochen.',
      link: 'https://safranwunder.de/pages/balance-typ-cortisol'
    },
    hormonal: {
      name: 'Die Hormonal Unausgeglichene',
      tag: 'Dein System reagiert auf hormonelle Verschiebungen – das ist keine Schwäche, sondern Biologie.',
      sub: 'Für hormonell bedingte Ungleichgewichte ist kontinuierliche Unterstützung wichtig – Veränderungen zeigen sich nach 4–6 Wochen.',
      link: 'https://safranwunder.de/pages/balance-typ-hormonell'
    },
    performer: {
      name: 'Die stille Überperformerin',
      tag: 'Du funktionierst hervorragend – aber dein inneres System zahlt gerade einen Preis dafür.',
      sub: 'Für Typ „Stille Überperformerin" ist Regelmäßigkeit entscheidend. Eine tägliche Abendroutine hat sich als besonders wirksam erwiesen.',
      link: 'https://safranwunder.de/pages/balance-typ-performerin'
    },
    drained: {
      name: 'Die Erschöpfte Seele',
      tag: 'Dein inneres Reservoir ist leer. Es ist Zeit, zuerst dir selbst zu geben.',
      sub: 'Für Typ „Erschöpfte Seele" empfehlen wir den längsten Einnahmezeitraum – dein System braucht Zeit und Konstanz zur Regeneration.',
      link: 'https://safranwunder.de/pages/balance-typ-erschoepft'
    }
  };

  const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[char]);

  roots.forEach((root) => initQuiz(root));

  function initQuiz(root) {
    const body = root.querySelector('[data-quiz-body]');
    const card = root.querySelector('[data-quiz-card]');
    const progress = root.querySelector('[data-progress]');
    const progressLabel = root.querySelector('[data-progress-label]');
    const progressPct = root.querySelector('[data-progress-pct]');
    const progressFill = root.querySelector('[data-progress-fill]');
    const answers = {};
    const history = [];
    let step = 'start';

    function getProfileKey() {
      const q1 = answers.q1 || [];
      const q2 = answers.q2 || '';
      const q4 = answers.q4 || '';
      if (q2 === 'hormonal') return 'hormonal';
      if (q4 === 'push-through' || (q1.includes('exhausted') && q2 === 'mental')) return 'performer';
      if (q1.includes('unmotivated') || q4 === 'withdraw') return 'drained';
      return 'cortisol';
    }

    function updateProgress() {
      if (step === 'start' || step === 'email') {
        progress.style.display = 'none';
        return;
      }

      progress.style.display = 'block';
      const questionIndex = questions.findIndex((question) => question.id === step) + 1;
      if (questionIndex > 0) {
        const pct = Math.max(12, Math.round((questionIndex / questions.length) * 100));
        progressLabel.textContent = `Frage ${questionIndex} von ${questions.length}`;
        progressPct.textContent = `${pct}%`;
        progressFill.style.width = `${pct}%`;
        return;
      }

      progressLabel.textContent = 'Fast fertig …';
      progressPct.textContent = '100%';
      progressFill.style.width = '100%';
    }

    function setStep(nextStep, pushHistory = true) {
      if (pushHistory) history.push(step);
      step = nextStep;
      updateProgress();
      render();
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderStart() {
      body.innerHTML = `
        <div class="gs-quiz__step gs-quiz__start">
          <div class="gs-quiz__start-icon">⚖</div>
          <h2>Wie ausgeglichen ist dein inneres System wirklich?</h2>
          <p>Dieser Check erkennt das häufigste Ungleichgewichtsmuster bei Frauen – und zeigt dir, was dahintersteckt.</p>
          <div class="gs-quiz__avatars">
            <div class="gs-quiz__avatar" style="background:linear-gradient(135deg,#9cb8d4,#4a7ba7)">S</div>
            <div class="gs-quiz__avatar" style="background:linear-gradient(135deg,#c4a0c0,#8b5c8b)">M</div>
            <div class="gs-quiz__avatar" style="background:linear-gradient(135deg,#a0c4b0,#4a8b6a)">K</div>
            <div class="gs-quiz__avatar" style="background:linear-gradient(135deg,#d4a843,#8B6914)">+</div>
          </div>
          <div class="gs-quiz__count">47.312 Teilnehmerinnen</div>
          <div class="gs-quiz__badges"><span class="gs-quiz__badge">⏱ Ca. 2 Minuten</span><span class="gs-quiz__badge">🔒 Anonym & kostenlos</span><span class="gs-quiz__badge">📊 Sofortiges Ergebnis</span></div>
          <button class="gs-quiz__button gs-quiz__button--gold" type="button" data-start>Check jetzt starten →</button>
        </div>
      `;
      body.querySelector('[data-start]').addEventListener('click', () => setStep('q1'));
    }

    function renderQuestion(question) {
      const selected = answers[question.id] || (question.type === 'multi' ? [] : '');
      body.innerHTML = `
        <div class="gs-quiz__step">
          <div class="gs-quiz__num">Frage ${questions.indexOf(question) + 1} von ${questions.length}</div>
          <div class="gs-quiz__question">${escapeHtml(question.text)}</div>
          <div class="gs-quiz__hint">${escapeHtml(question.hint)}</div>
          <div class="gs-quiz__options">
            ${question.options.map(([value, label]) => {
              const isSelected = Array.isArray(selected) ? selected.includes(value) : selected === value;
              return `<button class="gs-quiz__option${isSelected ? ' is-selected' : ''}" type="button" data-option="${escapeHtml(value)}" data-multi="${question.type === 'multi'}"><span class="gs-quiz__dot"></span><span>${escapeHtml(label)}</span></button>`;
            }).join('')}
          </div>
          ${question.auto ? '' : '<button class="gs-quiz__button gs-quiz__next" type="button" data-next>Weiter →</button>'}
          <button class="gs-quiz__button gs-quiz__back" type="button" data-back>← Zurück</button>
        </div>
      `;

      const nextButton = body.querySelector('[data-next]');
      const syncNext = () => {
        if (!nextButton) return;
        const hasAnswer = question.type === 'multi' ? (answers[question.id] || []).length > 0 : Boolean(answers[question.id]);
        nextButton.classList.toggle('is-ready', hasAnswer);
      };

      body.querySelectorAll('[data-option]').forEach((option) => {
        option.addEventListener('click', () => {
          const value = option.dataset.option;
          if (question.type === 'multi') {
            const current = answers[question.id] || [];
            if (current.includes(value)) {
              answers[question.id] = current.filter((item) => item !== value);
              option.classList.remove('is-selected');
            } else if (current.length < question.max) {
              answers[question.id] = [...current, value];
              option.classList.add('is-selected');
            }
            syncNext();
            return;
          }

          answers[question.id] = value;
          body.querySelectorAll('[data-option]').forEach((item) => item.classList.remove('is-selected'));
          option.classList.add('is-selected');
          if (question.auto) {
            setTimeout(goForward, 420);
          } else {
            syncNext();
          }
        });
      });

      if (nextButton) nextButton.addEventListener('click', goForward);
      body.querySelector('[data-back]').addEventListener('click', goBack);
      syncNext();
    }

    function goForward() {
      const index = questions.findIndex((question) => question.id === step);
      if (index === questions.length - 1) {
        startLoading();
        return;
      }
      setStep(questions[index + 1].id);
    }

    function goBack() {
      const previous = history.pop();
      if (previous) setStep(previous, false);
    }

    function startLoading() {
      step = 'loading';
      updateProgress();
      body.innerHTML = `
        <div class="gs-quiz__step gs-quiz__loading">
          <h2>Dein Balance-Profil wird erstellt …</h2>
          <p class="gs-quiz__hint">Wir analysieren deine Antworten und ordnen dein Muster zu.</p>
          <div class="gs-quiz__analysis">
            <div class="gs-quiz__analysis-row" data-analysis-row>⚖ <span>Symptom-Muster auswerten</span></div>
            <div class="gs-quiz__analysis-row" data-analysis-row>🧬 <span>Balance-Typ zuordnen</span></div>
            <div class="gs-quiz__analysis-row" data-analysis-row>📋 <span>Persönliche Empfehlung erstellen</span></div>
          </div>
          <div class="gs-quiz__load-track"><div class="gs-quiz__load-fill" data-load-fill></div></div>
          <div class="gs-quiz__load-pct" data-load-pct>0%</div>
        </div>
      `;

      [...body.querySelectorAll('[data-analysis-row]')].forEach((row, index) => {
        setTimeout(() => row.classList.add('is-done'), 650 + index * 800);
      });

      const fill = body.querySelector('[data-load-fill]');
      const pct = body.querySelector('[data-load-pct]');
      let value = 0;
      const timer = setInterval(() => {
        value += 2;
        fill.style.width = `${value}%`;
        pct.textContent = `${value}%`;
        if (value >= 100) {
          clearInterval(timer);
          setTimeout(() => setStep('email', false), 350);
        }
      }, 45);
    }

    function renderEmail() {
      const profile = profiles[getProfileKey()];
      body.innerHTML = `
        <div class="gs-quiz__step gs-quiz__bridge">
          <h2>Deine Auswertung ist fertig!</h2>
          <p>Dein persönliches Balance-Profil wurde erstellt – inklusive konkreter Empfehlung für deinen Typ.</p>
          <div class="gs-quiz__teaser">
            <div class="gs-quiz__teaser-name">${escapeHtml(profile.name)}</div>
            <div class="gs-quiz__teaser-tag">${escapeHtml(profile.tag)}</div>
          </div>
          <a class="gs-quiz__product-button" href="${escapeHtml(profile.link)}">Mein Profil & Empfehlung ansehen →</a>
          <div class="gs-quiz__free-note"><span class="gs-quiz__check">✓</span> 100% kostenlos · Sofort verfügbar</div>
          <div class="gs-quiz__product">
            <div class="gs-quiz__product-label">Persönliche Empfehlung</div>
            <div class="gs-quiz__product-name">Safranwunder Balance Komplex</div>
            <p>${escapeHtml(profile.sub)}</p>
            <div class="gs-quiz__fine">Nahrungsergänzungsmittel sind kein Ersatz für ärztliche Behandlung. Individuelle Ergebnisse können variieren.</div>
          </div>
        </div>
      `;
    }

    function render() {
      if (step === 'start') {
        renderStart();
        return;
      }
      if (step === 'email') {
        renderEmail();
        return;
      }
      const question = questions.find((item) => item.id === step);
      if (question) renderQuestion(question);
    }

    updateProgress();
    render();
  }
})();
